import React, { Component } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { VendorContactPopUp } from '../components/VendorContactPopUp';
import RoleUtils from '../utils/roleUtils.js';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { Loading } from '../components/Loading';
import CommonUtils from '../utils/siteUtils.js';
import ServiceCalls from '../utils/serviceCalls.js';
import '../styles/Vendor.css';

export class VendorContacts extends Component {

    constructor(props) {
        super()
        this.handleClose = this.handleClose.bind(this);
        this.buildTable = this.buildTable.bind(this);
        this.onContactChange = this.onContactChange.bind(this);
        this.state = {
            contacts: [],
            isLoading: true,
            isReadOnly: true,
            spua: {},
        }
    }

    componentDidMount() {

        this.getVendorContacts();
    }

    //Get admin info update if props change i.e. company ID changes
    componentDidUpdate(prevProps) {
        if (prevProps.currentCompanyId !== this.props.currentCompanyId)
        { 
            this.getVendorContacts();
        }
    }

    getVendorContacts() {
        const { currentCompanyId, currentUser } = this.props;
        var readOnly = (this.props.vendorData.enabled === false) || !(RoleUtils.canAccess(currentUser, currentCompanyId, RoleUtils.profileEditNoBankRoles()));
        ServiceCalls.getSupplierAdmin(currentCompanyId).then(function (data) {
            if (data) {
                this.setState({
                    contacts: this.props.vendorData.vendorContacts,
                    spua:data,
                    isLoading: false,
                    isReadOnly: readOnly
                });
            }
            else {
                console.log(`Error getting SPUA for Supplier ${currentCompanyId} - Forcing Read Only`);
                this.setState({
                    contacts: this.props.vendorData.vendorContacts,
                    spua: {},
                    isLoading: false,
                    isReadOnly: true
                });
            }
        }.bind(this)); 
    }

    onContactChange() {
        const { currentCompanyId } = this.props;
        this.setState({
            isLoading: true,
        });

        ServiceCalls.getVendorInfo(Number(currentCompanyId)).then(function (results) {
            if (results) {
                this.setState({
                    contacts: results.vendorContacts,
                    isLoading: false,
                });
            }
            else {
                this.setState({
                    contacts: [],
                    isLoading: false
                });
            }
        }.bind(this));
    }
    //Handle close method for confirmModal
    handleClose() {
        this.setState({ statusChange: false });
    }

    buildTable() {
        const { /*currentUser, currentCompanyId,*/ vendorData } = this.props;
        const { contacts, isReadOnly, spua } = this.state;
        var isEMEASupplier = CommonUtils.determineIfVendorIsEMEAPlus(vendorData);
        var removeBtnText = (isEMEASupplier) ? "At least one contact must be defined, please reach out via the Contact Us page for assistance." : "";
        if (contacts.length > 0) {
            //Phase 3.2 - Do not allow Remove if EMEA Supplier only has 1 Contact
            
         
                var contactsRow = contacts.map(function (item, idx) {
                    // DE776199: Contact Label Row Misalignment
                    var contactName = (item.name) ? item.name : '\u00A0';
                    var contactBtns = (isReadOnly)
                        ? <></>
                        : (isEMEASupplier && contacts.length === 1)
                            ?<div className="contactBtns" >
                                    <VendorContactPopUp currentContact={item} vendorData={vendorData} supplierAdmin={spua} editMode="Edit" onVendorChange={this.onContactChange} />
                                <VendorContactPopUp currentContact={item} vendorData={vendorData} supplierAdmin={spua} editMode="Replace" onVendorChange={this.onContactChange} />
                                <OverlayTrigger
                                    overlay={<Tooltip>{removeBtnText}</Tooltip>}>
                                    <span>
                                        <Button className="vContactRemoveBtn" disabled={true}>Remove</Button>
                                    </span>
                                </OverlayTrigger>
                                
                                </div>
                            :<div className="contactBtns" >
                                <VendorContactPopUp currentContact={item} vendorData={vendorData} supplierAdmin={spua} editMode="Edit" onVendorChange={this.onContactChange} />
                                <VendorContactPopUp currentContact={item} vendorData={vendorData} supplierAdmin={spua} editMode="Replace" onVendorChange={this.onContactChange} />
                                <VendorContactPopUp currentContact={item} vendorData={vendorData} supplierAdmin={spua} editMode="Remove" onVendorChange={this.onContactChange} />
                            </div>;
                    return (
                        <Col key={idx} sm={3} className='contactArea'>
                            <div className='contactColumn'>
                                <div className='contactLabels'>Name</div>
                                <div className="contactField">{contactName}</div>
                            </div>
                            <div className='contactColumn'>
                                <div className='contactLabels'>Email</div>
                                <div className="contactField">{item.emailId}</div>
                            </div>
                            {contactBtns}
                        </Col>
                    );


                }, this);
            
            if (contacts.length > 4) {
                return (<div className="contactsRow">{contactsRow}</div>); 
            }
            else {
                return (<Row>{contactsRow}</Row>);
            }
        }
        else {
            return (<Row><Col><h4>No Contacts</h4></Col></Row>);
        }       
    }

    render() {
        const { isLoading, spua, isReadOnly } = this.state;  
        const { vendorData } = this.props;
        
        var display = (isLoading)
            ? <div style={{ margin: "auto", width: "100px" }}>
                <Loading />
            </div>
            : this.buildTable();
        var addBtn = (isReadOnly) ? <></> : <VendorContactPopUp currentContact={null} vendorData={vendorData} supplierAdmin={spua} editMode="Add" onVendorChange={this.onContactChange} />;
        return (
            <> 
                <Container fluid>
                    <Row className="access-headers">
                        <Col md={2}><h3 >Contacts</h3></Col>
                        <Col md={{ span: 1, offset: 9 }}>
                            {addBtn}
                        </Col>                        
                    </Row>
                </Container>
                <Container fluid className="vendorArea border-left-dark shadow borderCurve">
                    {display}
                </Container>
            </>
        )
    }
}